import { useEffect, useState } from "react";
import { ASSETS } from "@/lib/assets";
import { scrollToId, scrollToTop } from "@/lib/scroll";

const links = [
  { label: "The System", href: "#system" },
  { label: "How it works", href: "#how" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="logo-home"
          onClick={scrollToTop}
          className="flex items-center"
          aria-label="ASYA home"
        >
          <img src={ASSETS.logoWhite} alt="ASYA" className="h-5 md:h-6 w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              onClick={() => scrollToId(l.href)}
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="header-waitlist-button"
          onClick={() => scrollToId("#waitlist")}
          className="group inline-flex items-center gap-2 rounded-full bg-accent px-5 py-2.5 text-accent-foreground text-[11px] font-mono uppercase tracking-[0.2em] hover:bg-white transition-all duration-300"
        >
          Join waitlist
          <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
        </button>
      </div>
    </header>
  );
};
